import React, { FC, Fragment, useEffect, useState } from 'react';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import { AlertTitle } from '@mui/material';

type AlertSnackbarProps = {
    message: string;
    title?: string;
    type: 'success' | 'info' | 'warning' | 'error';
    onClose?: () => void;
};
const AlertSnackbar: FC<AlertSnackbarProps> = ({ type, title, message, onClose }: AlertSnackbarProps) => {
    const [open, setOpen] = useState(true);

    const closeHandler = () => {
        setOpen(false);
        if (onClose) {
            onClose();
        }
    };

    useEffect(() => {
        if (open) {
            setTimeout(() => {
                setOpen(false);
            }, 10000);
        }
    });

    return (
        <Snackbar
            autoHideDuration={10000}
            open={open}
            onClose={closeHandler}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        >
            <Alert
                variant="filled"
                onClose={closeHandler}
                severity={type}
                sx={{ minWidth: 320, boxShadow: 4 }}
                action={
                    <Fragment>
                        <IconButton size="small" aria-label="close" color="inherit" onClick={closeHandler}>
                            &#10006;
                        </IconButton>
                    </Fragment>
                }
            >
                {title ? <AlertTitle>{title}</AlertTitle> : undefined}
                {message}
            </Alert>
        </Snackbar>
    );
};

export default AlertSnackbar;
